
export const products = {
  'product.categories': 'Categorie di prodotti',
  'explore.solutions': 'Esplora la nostra gamma completa di soluzioni AV professionali',
  'view.video': 'Guarda il video di panoramica del prodotto',
  'AV Over IP': 'AV Su IP',
  'ReAX Control': 'Controllo ReAX',
  'Meeting Room Solutions': 'Soluzioni per Sale Riunioni',
  'Converters/Scalers': 'Convertitori/Scalatori',
  'Audio Products': 'Prodotti Audio',
  'HDMI Switchers': 'Commutatori HDMI',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'Prodotti HDBaseT',
  'Complete AV distribution solution with ultra-low latency': 'Soluzione completa di distribuzione AV con latenza ultra-bassa',
  'Professional control system solutions': 'Soluzioni professionali per sistemi di controllo',
  'Complete solutions for modern meeting spaces': 'Soluzioni complete per spazi di riunione moderni',
  'Professional format conversion and scaling solutions': 'Soluzioni professionali di conversione e scalatura di formato',
  'Professional audio processing and playback solutions': 'Soluzioni professionali di elaborazione e riproduzione audio',
  'Professional HDMI switching and distribution solutions': 'Soluzioni professionali di commutazione e distribuzione HDMI',
  'Advanced IP-based AV distribution platform': 'Piattaforma avanzata di distribuzione AV basata su IP',
  'Professional HDBaseT distribution solutions': 'Soluzioni professionali di distribuzione HDBaseT',
  'group.not.found': 'Gruppo non trovato',
  'product.not.found': 'Prodotto non trovato',
  'return.to.home': 'Ritorna alla home',
  'back.to.product.group': 'Torna al gruppo di prodotti',
  'overview': 'Panoramica',
  'full.description': 'Descrizione completa',
  'features': 'Caratteristiche',
  'specifications': 'Specifiche',
};
